const menuJson = {
  // 情报管理
  genList: [
    {
      name: 'IntelligenceManage', // 情报管理
      hasChildList: false,
      href: '/gen/allGen',
      menuLogo: 'icon-radarcopy2'
    }
  ],
  // 线索
  clueList: [
    {
      name: 'AndunClue',
      hasChildList: true,
      href: '',
      menuLogo: 'icon-clue-01',
      childList: [
        {
          name: 'PendingReview',
          hasChildList: false,
          href: '/clue/reviewedClue',
          menuLogo: ''
        }, {
          name: 'All',
          hasChildList: false,
          href: '/clue/allClue',
          menuLogo: ''
        },
        {
          name: 'CluesForTesting',
          hasChildList: false,
          href: '/clue/leadPurchase',
          menuLogo: ''
        }
      ]
    },
    {
      name: 'VendorClues',
      hasChildList: true,
      href: '',
      menuLogo: 'icon-clue-01',
      childList: [
        {
          name: 'PendingReview',
          hasChildList: false,
          href: '/clue/custReviewedClue',
          menuLogo: ''
        }, {
          name: 'All',
          hasChildList: false,
          href: '/clue/custAllClue',
          menuLogo: ''
        }
      ]
    }
  ],

  channelClueList: [
    {
      name: 'AndunClue',
      hasChildList: true,
      href: '',
      menuLogo: 'icon-clue-01',
      childList: [
        {
          name: 'All',
          hasChildList: false,
          href: '/channelClue/channelAllClue',
          menuLogo: ''
        }

      ]
    }
  ],
  // 个人中心
  personalCenterList: [
    {
      name: 'PersonalCenter',
      hasChildList: false,
      href: '/personalCenter/information',
      menuLogo: 'icon-user-01'
    }
  ],
  // 成员管理
  settingList: [
    {
      name: 'MemberManage', // 成员管理
      hasChildList: false,
      href: '/setting/memberManage',
      menuLogo: 'icon-investigation-01'
    }
  ],
  // // 渠道
  // channelList: [
  //   {
  //     name: 'Channel', // 渠道
  //     hasChildList: false,
  //     href: '/channel/channelInfo',
  //     menuLogo: 'icon-investigation-01'
  //   }
  // ],
  projectList: [
    {
      name: 'ProjectList', // 项目列表
      hasChildList: false,
      href: '/project/projectList',
      menuLogo: 'icon-project-03'
    }
  ],
  caseList: [
    {
      name: 'AndunCase',
      hasChildList: true,
      href: '',
      menuLogo: 'icon-project-03',
      childList: [
        {
          name: 'CivilCase',
          hasChildList: false,
          href: '/case/civilCase',
          menuLogo: ''
        },
        {
          name: 'AdministrativeCase',
          hasChildList: false,
          href: '/case/administrativeCase',
          menuLogo: ''
        },
        {
          name: 'CriminalCase',
          hasChildList: false,
          href: '/case/criminalCase',
          menuLogo: ''
        }
      ]
    },
    {
      name: 'VendorCase',
      hasChildList: false,
      href: '/case/customerCase',
      menuLogo: 'icon-project-03'
    }
  ],

  channelCaseList: [
    {
      name: 'AndunCase',
      hasChildList: true,
      href: '',
      menuLogo: 'icon-project-03',
      childList: [
        {
          name: 'CivilCase',
          hasChildList: false,
          href: '/channelCase/channelCivilCase',
          menuLogo: ''
        },
        {
          name: 'AdministrativeCase',
          hasChildList: false,
          href: '/channelCase/channelAdministrativeCase',
          menuLogo: ''
        },
        {
          name: 'CriminalCase',
          hasChildList: false,
          href: '/channelCase/channelCriminalCase',
          menuLogo: ''
        }
      ]
    }

  ],
  // 结算中心列表
  settlementCenterList: [
    {
      name: 'InvoiceManage',
      hasChildList: true,
      href: '',
      menuLogo: 'icon-post-01',
      childList: [
        {
          name: 'InvoiceList',
          hasChildList: false,
          href: '/settlementCenter/invoicing/list/index',
          menuLogo: ''
        }
      ]
    }
  ],
  // 供应商管理
  supplierList: [
    {
      name: 'SupplierManage',
      hasChildList: false,
      href: '/supplier/supplierManage',
      menuLogo: 'icon-project-03'
    }
  ],
  toolList: [
    {
      name: 'CopyrightInfringe',
      hasChildList: true,
      href: '',
      menuLogo: 'icon-tort-01',
      childList: [
        {
          name: 'OnlineMonitor',
          hasChildList: false,
          href: '/tools/onlineMonitor',
          menuLogo: ''
        },
        {
          name: 'oldOnlineMonitor',
          hasChildList: false,
          href: '/tools/oldOnlineMonitor',
          menuLogo: ''
        },
        {
          name: 'OfflineMonitor',
          hasChildList: false,
          href: '/tools/offlineMonitor',
          menuLogo: ''
        }
      ]
    }
    // {
    //   name: 'OwnershipSearch',
    //   hasChildList: true,
    //   href: '',
    //   menuLogo: 'icon-project-03',
    //   childList: [{
    //     name: 'PatentSearch',
    //     hasChildList: false,
    //     href: '/tools/zhihuiya',
    //     menuLogo: ''
    //   }]
    // }

  ]
}

export default {
  menuJson
}



// WEBPACK FOOTER //
// ./src/libs/menu.js